import { ChatBox } from "@100mslive/hms-video-react";
import { useHMSStore } from '@100mslive/hms-video-react';
import { selectLocalPeer } from '@100mslive/hms-video-store';
import { ROLES } from '../../common/roles';

export const ChatView = ({ toggleChat }) => {
  const localPeer = useHMSStore(selectLocalPeer);
  const iamGuest = localPeer?.roleName.toLowerCase() === ROLES.GUEST;

  return <ChatBox onClose={toggleChat} classes={{
    footer: iamGuest ? 'hidden' : ''
  }} />;
};
